/** Upscaling-preset endpoints (global, shared). */
import { api } from '../http'
import {
  UpscalingPresetSchema,
  UpscalingPresetsResponseSchema,
  type UpscalingPresetSpec,
} from '../schemas'

export const listUpscalingPresets = () =>
  api.get('/upscaling-presets', UpscalingPresetsResponseSchema)

export const createUpscalingPreset = (
  name: string,
  spec: UpscalingPresetSpec,
  isPublic = false,
) =>
  api.post(
    '/upscaling-presets',
    { name, spec, is_public: isPublic },
    UpscalingPresetSchema,
  )

export const updateUpscalingPreset = (
  id: string,
  name: string,
  spec: UpscalingPresetSpec,
  isPublic = false,
) =>
  api.put(
    `/upscaling-presets/${id}`,
    { name, spec, is_public: isPublic },
    UpscalingPresetSchema,
  )

/** DELETE → 204, no body. */
export const deleteUpscalingPreset = (id: string) =>
  api.del(`/upscaling-presets/${id}`)
